import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config/api';
import './ResetPassword.css';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Token de réinitialisation manquant');
    }
  }, [token]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Validation
    if (!formData.password || !formData.confirmPassword) {
      setError('Tous les champs sont obligatoires');
      setLoading(false);
      return;
    }

    if (formData.password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères');
      setLoading(false);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      setLoading(false);
      return;
    }

    if (!token) {
      setError('Token de réinitialisation manquant');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${API_URL}/auth/reset-password`, {
        token,
        password: formData.password
      });

      if (response.data.success) {
        setSuccess(true);
        // Rediriger vers la connexion après 3 secondes
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } else {
        setError(response.data.message || 'Une erreur est survenue');
      }
    } catch (err) {
      console.error('Erreur reset password:', err);
      setError(err.response?.data?.message || 'Le lien de réinitialisation est invalide ou a expiré');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="reset-password-container">
        <div className="reset-password-card">
          <div style={{ textAlign: 'center', padding: '2rem 0' }}>
            <h2 style={{ color: '#4caf50', marginBottom: '1rem' }}>✅ Mot de passe réinitialisé</h2>
            <p style={{ marginBottom: '1.5rem', color: '#666' }}>
              Votre mot de passe a été réinitialisé avec succès.
            </p>
            <p style={{ color: '#666', fontSize: '0.9rem' }}>
              Vous allez être redirigé vers la page de connexion...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="reset-password-container">
      <div className="reset-password-card">
        <h2>🔑 Réinitialiser votre mot de passe</h2>
        <p className="form-subtitle">Entrez votre nouveau mot de passe</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="password">Nouveau mot de passe</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="••••••••"
              disabled={loading}
              required
              minLength={8}
            />
            <small style={{ color: '#666', fontSize: '0.85rem' }}>
              Au moins 8 caractères
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="••••••••"
              disabled={loading}
              required
              minLength={8}
            />
          </div>

          {error && (
            <div className="alert-error">
              ❌ {error}
            </div>
          )}

          <button
            type="submit"
            className="btn-primary"
            disabled={loading || !token}
          >
            {loading ? '⏳ Réinitialisation...' : '🔑 Réinitialiser le mot de passe'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
